import type { Metadata } from "next";

export const siteUrl = "https://codiaj.com";

const BASE_TITLE = "Codiaj · Diseño web para restaurantes y empresas · Madrid";
const BASE_DESCRIPTION =
  "Diseño web profesional para restaurantes, pymes y empresas en Madrid. SEO local, WhatsApp, reservas y webs corporativas rápidas sin pago inicial.";

export interface ConstructMetadataArgs {
  title?: string;
  description?: string;
  path?: string;
}

export function constructMetadata(
  args: ConstructMetadataArgs = {},
): Metadata {
  const title = args.title ?? BASE_TITLE;
  const description = args.description ?? BASE_DESCRIPTION;
  const fullUrl = args.path ? `${siteUrl}${args.path}` : siteUrl;

  return {
    metadataBase: new URL(siteUrl),
    title,
    description,
    applicationName: "Codiaj",
    authors: [{ name: "Codiaj", url: siteUrl }],
    creator: "Codiaj",
    publisher: "Codiaj",
    keywords: [
      "diseño web",
      "diseño web Madrid",
      "diseño web para restaurantes",
      "web para restaurantes Madrid",
      "SEO local restaurantes",
      "página web restaurante",
      "carta digital restaurante",
      "reservas online restaurante",
      "web corporativa Madrid",
      "diseño web corporativo",
      "agencia digital Madrid",
      "SEO local Madrid",
      "web para autónomos",
      "web para pymes",
      "sin pago inicial",
      "diseño web sin anticipo",
      "automatización pymes",
      "página web barata Madrid",
      "presupuesto web Madrid",
      "agencia SEO Madrid",
      "desarrollo web Madrid",
      "Madrid",
      "agencia",
      "SEO",
      "pymes",
      "autónomos",
    ],
    alternates: {
      canonical: fullUrl,
      languages: {
        'es-ES': fullUrl,
      },
    },
    openGraph: {
      title,
      description,
      url: fullUrl,
      locale: "es_ES",
      type: "website",
      siteName: "Codiaj",
      images: [
        {
          url: "/brand/metaog.png",
          width: 1200,
          height: 630,
          alt: "Codiaj - Diseño Web Profesional",
        },
      ],
    },
    twitter: {
      card: "summary_large_image",
      title,
      description,
      images: ["/brand/metaog.png"],
    },
    icons: {
      icon: "/brand/Logo_CodiaJ_Redondo_Fondo_Negro.png",
      apple: "/brand/Logo_CodiaJ_Redondo_Fondo_Negro.png",
    },
    robots: {
      index: true,
      follow: true,
    },
  };
}
